import { Reveal } from "./Reveal";

const MARQUEE_WORDS = [
    "Meet people already around you",
    "See who’s open",
    "Wave",
    "Say hello",
];

const MarqueeRow = () => (
    <div className="flex shrink-0 items-center">
        {MARQUEE_WORDS.map((word, i) => (
            <span key={i} className="flex items-center">
                <span className="whitespace-nowrap px-8 text-xs font-medium uppercase tracking-[0.3em] text-[#899B6A]">
                    {word}
                </span>
                <span className="h-1 w-1 rounded-full bg-[#4A5D23]" aria-hidden="true" />
            </span>
        ))}
    </div>
);

export const Manifesto = () => (
    <section
        data-testid="brand-manifesto-section"
        className="overflow-hidden bg-[#1D201A] text-[#F9F8F4]"
    >
        <div className="border-y border-[#2A2C27] py-4" aria-hidden="true">
            <div className="marquee-track flex w-max">
                <MarqueeRow />
                <MarqueeRow />
                <MarqueeRow />
                <MarqueeRow />
            </div>
        </div>
        <div className="mx-auto max-w-6xl px-6 py-28 sm:py-40">
            <Reveal>
                <p className="text-[11px] font-medium uppercase tracking-[0.28em] text-[#899B6A]">
                    06 — Manifesto
                </p>
                <h2
                    data-testid="brand-statement-large"
                    className="font-display mt-8 max-w-4xl text-[2.6rem] font-medium leading-[1.08] tracking-tight sm:text-6xl lg:text-7xl"
                >
                    Use your phone to get{" "}
                    <em className="italic text-[#A8B888]">off your phone</em>.
                </h2>
                <p
                    data-testid="brand-statement-small"
                    className="mt-8 text-base text-[#899B6A] sm:text-lg"
                >
                    Less scrolling. More meeting.
                </p>
            </Reveal>
        </div>
    </section>
);
